import { createModel } from '@rematch/core';
import { PlatformSkuLabel, SkuGalleryLabel } from 'domains/gallerySkuDomain';
import type { RootModel } from 'models';
import gallerySkuService from 'services/gallerySkuService';
import {
  SkuGalleryLabelCreateParams,
  SkuGalleryLabelUpdateParams,
} from 'domains/gallerySkuDomain';
import { baseReducers, BaseState } from './baseReducers';

interface GalleryLabelState extends BaseState {
  data?: PlatformSkuLabel;
  item?: SkuGalleryLabel | SkuGalleryLabelCreateParams;
}

export const galleryLabel = createModel<RootModel>()({
  state: {
    data: undefined,
    item: undefined,
  } as GalleryLabelState,
  reducers: {
    ...baseReducers<GalleryLabelState>(),
    reset: (state: GalleryLabelState) => {
      state.item = undefined;
      return state;
    },
  },
  effects: (dispatch) => {
    const { galleryLabel } = dispatch;
    return {
      async getList(): Promise<void> {
        let resp = await gallerySkuService.getGalleryLabels();
        galleryLabel.setState({
          data: resp,
        });
      },

      async createItem(
        payload: SkuGalleryLabelCreateParams,
        rootState
      ): Promise<void> {
        // create new
        payload.isCompany
          ? await gallerySkuService.createCompanyLabel(payload)
          : await gallerySkuService.createGalleryLabel(payload);
        await galleryLabel.getList();
      },

      async updateItem(
        payload: SkuGalleryLabelUpdateParams,
        rootState
      ): Promise<void> {
        // update existing
        payload.isCompany
          ? await gallerySkuService.updateCompanyLabel(payload)
          : await gallerySkuService.updateGalleryLabel(payload);

        await galleryLabel.getList();
      },

      async removeItem(
        payload: SkuGalleryLabelUpdateParams,
        rootState
      ): Promise<void> {
        payload.isCompany
          ? gallerySkuService.removeCompanyLabel(payload.id)
          : gallerySkuService.removeGalleryLabel(payload.id);
        await galleryLabel.getList();
      },
    };
  },
});
